import { IMergeTags, IBudget, IAllProposalDetails } from '@opengov/stories-shared/types';
import { postJson } from '../../../../utils/fetchUtils';

export type IMergeTagsResponse = {
  storyBudget?: IBudget;
  proposalFieldsDetails?: IAllProposalDetails;
  mergeTags?: IMergeTags;
  // Error response fields
  message?: string;
  err?: unknown;
};

/**
 * Fetches merge tags for a story from the proposals API
 */
export const fetchMergeTags = async (storyId: string, entityId: number): Promise<IMergeTags> => {
  const response = await postJson<IMergeTagsResponse>('/api/stories/v1/stories/getProposalsInStory', {
    story_id: storyId,
    entity_id: entityId
  });

  return response?.mergeTags || {};
};
